(function () {
	function ready(fn) {
		if (document.readyState !== "loading") fn();
		else document.addEventListener("DOMContentLoaded", fn);
	}

	function findTile(user) {
		return document.querySelector(`.qcs-tile[data-user="${CSS.escape(user)}"]`);
	}

	function escapeHtml(s) {
		if (s === undefined || s === null) return "";
		return String(s).replace(/[&<>"']/g, (c) => ({
			"&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;",
		}[c]));
	}

	function refreshTileCounts(user) {
		if (!window.frappe || !frappe.call) return;
		frappe.call({
			method: "qcs_team_sync.api.mobile.team_today",
			callback: (r) => {
				if (!r || !r.message) return;
				r.message.tiles.forEach((t) => {
					const tile = findTile(t.user);
					if (!tile) return;
					const d = tile.querySelector('[data-field="open_tasks_today"]');
					const a = tile.querySelector('[data-field="open_tasks_total"]');
					if (d) d.textContent = t.open_tasks_today;
					if (a) a.textContent = t.open_tasks_total;
				});
			},
		});
	}

	function onCheckinPosted(msg) {
		const tile = findTile(msg.user);
		if (!tile) return;
		const sub = tile.querySelector(".qcs-sub");
		if (!sub) return;
		sub.innerHTML = `<span class="qcs-focus">${escapeHtml(msg.mood || "")} ${escapeHtml(
			(msg.today || "").slice(0, 90)
		)}</span>`;
		tile.classList.add("qcs-pulse");
		setTimeout(() => tile.classList.remove("qcs-pulse"), 1200);
	}

	function onLeaveUpdated(msg) {
		const tile = findTile(msg.user);
		if (!tile) return;
		const sub = tile.querySelector(".qcs-sub");
		if (!sub) return;
		if (msg.action === "created") {
			const today = document.querySelector(".qcs-team-today")?.dataset.today;
			if (today && msg.from_date <= today && today <= msg.to_date) {
				sub.innerHTML = `<span class="pill pill-leave">On Leave — ${escapeHtml(msg.type)}</span>`;
				tile.dataset.onLeave = "1";
			}
		} else if (msg.action === "deleted") {
			tile.dataset.onLeave = "0";
			sub.innerHTML = `<span class="qcs-muted">Back today</span>`;
		}
	}

	function onTaskUpdated(msg) {
		if (msg.assigned_to) refreshTileCounts(msg.assigned_to);
	}

	ready(() => {
		if (!document.querySelector(".qcs-team-today")) return;
		if (!window.frappe || !frappe.realtime) return;

		frappe.realtime.on("qcs_checkin_posted", onCheckinPosted);
		frappe.realtime.on("qcs_leave_updated", onLeaveUpdated);
		frappe.realtime.on("qcs_task_created", onTaskUpdated);
		frappe.realtime.on("qcs_task_updated", onTaskUpdated);

		frappe.realtime.emit("join_room_by_name", "qcs:team_today");
	});
})();
